import styled from 'styled-components';

import { IconEditRemove, Topbar as TopbarComponent } from '@make.tv/lib-web-uicomponents';
import { ReactComponent as LogoPortal } from 'assets/images/portal-logo.svg';
import { modifier } from 'Styles/utils';

export const Nav = styled.nav`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);

  .ltn.topbar {
    box-shadow: none;
  }
`;

export const PrimaryNavbar = styled(TopbarComponent)`
  .ltn.topbar-item {
    flex-shrink: 1;
    min-width: 0;
  }

  .ltn.top-menu {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    overflow: hidden;
  }

  .ltn.top-menu__right {
    display: flex;
    align-items: center;
    margin-left: auto;
    flex-shrink: 0;
    white-space: nowrap;
  }

  .ltn.top-menu__left {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    flex-shrink: 1;
    min-width: 0;
    overflow: visible;
    height: 32px;
    margin: 16px 0;
    padding: 0;
    width: auto;
  }

  .ltn.top-menu__left button {
    white-space: nowrap;
  }

  .ltn.topbar-logo {
    margin-right: 0;
    background: none;
  }
`;

export const PortalLogo = styled(LogoPortal)`
  width: 95.4px;
  height: 15px;
  margin: 7.9px 0 9.4px;
  object-fit: contain;
`;

export const LogoArea = styled.div`
  width: 129px;
  height: 64px;
  flex-grow: 0;
  padding: 16.1px 17.6px 15.6px 16px;
`;

export const SecondaryNavbar = styled(TopbarComponent)`
  .ltn.topbar-logo {
    padding: 0;
  }
`;

export const SubNav = styled.div`
  display: flex;
  gap: 8px;

  .button#newBookingBtn {
    margin: 0 8px 0 12px;
  }
`;

export const AccountId = styled.div`
  ${modifier('warn')`
    color: ${({ theme }) => theme.colors.textWarning};
  `}

  &:before {
    content: "(";
  }
  &:after {
    content: ")";
  }
`;

export const ImpersonationExit = styled(IconEditRemove).attrs({ size: 'sm' })`
  margin-left: 3px;
  color: ${({ theme }) => theme.colors.textWarning};
  &:hover {
    cursor: pointer;
  }
`;

export const MessageStatusContainer = styled.div`
  background: rgba(200, 121, 25, 0.3);
  border-radius: 2px;
  display: flex;
  justify-content: center;
`;

export const MessageInfoContainer = styled.div`
  background: rgba(4, 201, 76, 0.3);
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .MessageStatus_root__fLVtz {
    background-color: rgba(0, 0, 0, 0);
    align-items: center;
  }
  .MessageStatus_contentContainer__Q-YIf {
    flex-direction: row;
    align-items: center;
  }
  > .button {
    position: absolute;
    right: 0;
  }
`;
